import React, { createContext, useContext, useEffect, useState } from "react";

export const PermissionsContext = createContext(null);

export const PermissionsProvider = ({ children }) => {
  const [role, setRole] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);

  // This will be called from Dashboard after login/module click
  const updatePermissions = (userInfo) => {
    const isAdmin = userInfo?.is_branch_admin || userInfo?.is_super_admin;
    setRole(isAdmin ? "admin" : "user");
    setSubscriptionData(userInfo?.package_access || null);
  };

  // Restore subscription data from localStorage on page refresh
  useEffect(() => {
    const restoreFromStorage = () => {
      try {
        const loggedInUserInfo = localStorage.getItem("loggedInUserInfo");
        const packageAccess = localStorage.getItem("package_access");
        
        if (loggedInUserInfo && packageAccess) {
          const userInfo = JSON.parse(loggedInUserInfo);
          const subscriptionData = JSON.parse(packageAccess);
          
          const isAdmin = userInfo?.is_branch_admin || userInfo?.is_super_admin;
          setRole(isAdmin ? "admin" : "user");
          setSubscriptionData(subscriptionData);
          
        }
      } catch (error) {
        console.error("Error restoring subscription data:", error);
      }
    };

    restoreFromStorage();
  }, []);

  useEffect(() => {
    console.log("subscriptionData updated:", subscriptionData);
  }, [subscriptionData]);

  return (
    <PermissionsContext.Provider
      value={{ role, subscriptionData, updatePermissions }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);